<div class="container-fluid">
    <div class="row row-sm mg-t-20" style="height: 88vh;">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <iframe width="100%" height="100%" frameborder="0" style="border:0" allowfullscreen [src]="urlSafe"></iframe>
        </div><!-- col-6 -->

    </div>
    <br />
</div>